import React from "react";
import {Button, Icon, Table, Image} from "semantic-ui-react";
import _ from "lodash";

function PictureTable(
    {
        pictures,
        handleDownload
    }
){
    return (
        <>
            <div style={{marginBottom: 10}}>
                <Table celled>
                    <Table.Header>
                        <Table.Row>
                            <Table.HeaderCell>Name</Table.HeaderCell>
                            <Table.HeaderCell>Picture</Table.HeaderCell>
                            <Table.HeaderCell>Download</Table.HeaderCell>
                        </Table.Row>
                    </Table.Header>
                    <Table.Body>

                        {
                            _.times(pictures.length, (i) => (
                                <>
                                    <Table.Row>
                                        <Table.Cell>
                                            {pictures[i].name}
                                        </Table.Cell>
                                        <Table.Cell>
                                            <Image size='tiny' src={pictures[i].file}></Image>
                                        </Table.Cell>
                                        <Table.Cell>
                                            <Button onClick={()=>handleDownload(pictures[i].file, pictures[i].name)}>
                                                Download
                                            </Button>
                                        </Table.Cell>
                                    </Table.Row>
                                </>
                            ))
                        }
                    </Table.Body>
                </Table>
            </div>
        </>
    )
}

export default PictureTable
